if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        const legacyId = this.form?.querySelector('[name=id]');
        if (legacyId) legacyId.disabled = false;

        this.cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.spinner = this.querySelector('.loading__spinner');
        this.hideErrors = this.dataset.hideErrors === 'true';

        this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));

        if (document.querySelector('cart-drawer')) {
          this.submitButton?.setAttribute('aria-haspopup', 'dialog');
        }
      }

      // -------------------------
      // Helpers
      // -------------------------
      setLoading(isLoading) {
        if (!this.submitButton) return;

        if (isLoading) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
          this.spinner?.classList.remove('hidden');
        } else {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.spinner?.classList.add('hidden');
        }
      }

      buildAddConfig() {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;
        return { config, formData };
      }

      // Soma SOMENTE os produtos, não conta brindes do buy-buttons
      calcTotalFromForm() {
        const qtyInputs = this.form?.querySelectorAll(
          'input.variant-quantity[name^="items["][name$="][quantity]"]'
        );

        if (!qtyInputs || !qtyInputs.length) return 1;

        let total = 0;

        qtyInputs.forEach((input) => {
          if (input.classList.contains('gift-qty')) return;

          const n = Number(input.value || 0);
          if (Number.isFinite(n) && n > 0) total += n;
        });

        return total;
      }

      // Pega um variantId principal para o pubsub, ignorando brinde
      getPrimaryVariantIdFromForm() {
        const ids = this.form?.querySelectorAll(
          'input.variant-id[name^="items["][name$="][id]"]'
        );
        const qtys = this.form?.querySelectorAll(
          'input.variant-quantity[name^="items["][name$="][quantity]"]'
        );

        if (!ids?.length || !qtys?.length) return null;

        const len = Math.min(ids.length, qtys.length);

        for (let i = 0; i < len; i++) {
          if (qtys[i].classList.contains('gift-qty')) continue;

          const q = Number(qtys[i].value || 0);
          if (Number.isFinite(q) && q > 0) return ids[i].value;
        }

        return null;
      }

      // -------------------------
      // Brindes pelo buy-buttons
      // -------------------------
      setGiftQty(giftKey, qty) {
        const input = this.form?.querySelector(`.gift-qty[data-gift-key="${giftKey}"]`);
        if (input) input.value = String(qty);
      }

      resetAllGifts() {
        const allGiftQty = this.form?.querySelectorAll('.gift-qty[data-gift-key]');
        allGiftQty?.forEach((inp) => {
          inp.value = '0';
        });
      }

      applyGiftsFromConditions({
        lpClientes,
        totalCarrinho,
        valorMinimoBrinde4,
        valorMinimoBrinde6,
        valorMinimoBrinde1,
        valorNaoEntraBrinde1,
      }) {
        // Zera tudo antes, evitando ficar ligado de submits anteriores
        this.resetAllGifts();

        // Brinde 1 — total >= valorMinimoBrinde1
        // if (totalCarrinho >= valorMinimoBrinde1 && totalCarrinho != valorNaoEntraBrinde1) {
        //   this.setGiftQty('BRINDE1_ID', 1);
        // }

        // Brinde 3 — sempre
        this.setGiftQty('BRINDE3_ID', 1);

        // Brinde 5 — sempre LP-CLIENTES
        // if (lpClientes) {
        //   this.setGiftQty('BRINDE5_ID', 1);
        // }

        // Brinde 4 — lpClientes e total >= valorMinimoBrinde4
        // if (lpClientes && totalCarrinho >= valorMinimoBrinde4) {
        //   this.setGiftQty('BRINDE4_ID', 1);
        // }

        // Brinde 6 — lpClientes e total >= valorMinimoBrinde6
        if (lpClientes && totalCarrinho >= valorMinimoBrinde6) {
          this.setGiftQty('BRINDE6_ID', 1);
        }
      }

      setGiftVariantId(giftKey, variantId) {
        const input = this.form?.querySelector(`.gift-id[data-gift-key="${giftKey}"]`);
        if (input) input.value = String(variantId);
      }

      // -------------------------
      // Submit
      // -------------------------
      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.setLoading(true);

        const urlAtual = window.location.href;
        const lpClientes = urlAtual.includes('bready-clientes');

        const valorMinimoBrinde2 = 5; // Máquina de waffle
        const valorMinimoBrinde4 = 5;
        const valorMinimoBrinde6 = 3;
        const valorMinimoBrinde1 = 4;
        const valorNaoEntraBrinde1 = 5;

        // Total calculado pelo form, só produtos
        const totalCarrinho = this.calcTotalFromForm();

        // Aplica brindes no próprio form antes de montar o FormData
        this.applyGiftsFromConditions({
          lpClientes,
          totalCarrinho,
          valorMinimoBrinde4,
          valorMinimoBrinde6,
          valorMinimoBrinde1,
          valorNaoEntraBrinde1,
        });

        if (totalCarrinho >= valorMinimoBrinde2 && window.popupWatt?.open) {
          const chosenVariantId = await new Promise((resolve) => {
            window.popupWatt.open(resolve);
          });

          if (chosenVariantId) {
            // Troca o ID do brinde 110/220 e liga a quantidade
            this.setGiftVariantId('BRINDE2_ID', chosenVariantId);
            this.setGiftQty('BRINDE2_ID', 1);
          } else {
            // Usuário fechou sem escolher, então não adiciona a máquina
            this.setGiftQty('BRINDE2_ID', 0);
            this.setLoading(false);
            return;
          }
        } else {
          // Menos que o valor mínimo, garante que não vai
          this.setGiftQty('BRINDE2_ID', 0);
        }

        try {
          const { config } = this.buildAddConfig();

          // 1) Limpa carrinho
          await fetch('/cart/clear.js', { method: 'POST' });

          // 2) Adiciona tudo de uma vez: produtos + brindes do form
          const res = await fetch(`${routes.cart_add_url}`, config);
          const response = await res.json();

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: this.getPrimaryVariantIdFromForm(),
            cartData: response,
          });

          const quickAddModal = this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => setTimeout(() => this.cart.renderContents(response)),
              { once: true }
            );

            quickAddModal.hide(true);
          } else {
            this.cart?.renderContents(response);
          }

          window.location = window.routes.cart_url;
        } catch (err) {
          console.error(err);
        } finally {
          this.setLoading(false);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}